import { COMPANY_NAME_NO_SPACE } from "./strings";

export const LOCAL_STORAGE_KEY_SITE_JWT_TOKEN = COMPANY_NAME_NO_SPACE + "JWTToken";

export const passwordConstraints = [8, 30];
